import type { SourceCard } from "../Types/SourceTypes";

export const BASE_SOURCES: SourceCard[] = [
  { name: "Shopify", icon: "/Icons/Shopify.svg", className: "shopify" },
  { name: "Facebook", icon: "/Icons/FB.svg", className: "facebook" },
  { name: "GoogleAds", icon: "/Icons/Ads.svg", className: "google-ads" },
  { name: "MetaAds", icon: "/Icons/meta-logo.webp", className: "meta-ads" },
  {
    name: "GoogleAnalytics4",
    icon: "/Icons/GA.svg",
    className: "google-analytics",
  },
  { name: "Instagram", icon: "/Icons/Instalogo.png", className: "instagram" },
  { name: "WhatsApp", icon: "/Icons/WhatsApp.svg", className: "whatsapp" },
];

export const ODOO_SOURCE: SourceCard = {
  name: "Odoo",
  icon: "/images/odoo.svg",
  className: "odoo",
};

export const SOURCE_ID_TO_NAME_MAP: Record<number, string> = {
  1: "Shopify",
  2: "Facebook",
  3: "Instagram",
  4: "GoogleAds",
  5: "GoogleAnalytics4",
  6: "MetaAds",
  7: "WhatsApp",
};

export const ONBOARDING_SOURCE_ID_TO_NAME_MAP: Record<number, string> = {
  1: "Shopify",
  2: "Facebook",
  3: "Instagram",
  4: "GoogleAds",
  5: "GoogleAnalytics",
};

export const ONBOARDING_SOCIAL_MEDIA_ORDER: string[] = [
  "Shopify",
  "GoogleAds",
  "GoogleAnalytics",
  "Meta",
  "Facebook",
  "Instagram",
  "Snapchat",
  "Finish",
];
